<template>
  <div style="height: 250px" class="p-0">
    <b-modal
      id="modal-filter-removal-notice"
      title="Achtung: Filterdaten werden zurückgesetzt"
      centered
      ><!-- modal -->
      <div>
        <p>
          Kundenname/Kundenemail, Kundenadress- und Zeitspannenfilter werden
          entfernt, wenn Sie sich entscheiden die Zusatzfelder wieder
          ausblenden.
        </p>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-btn
            size="md"
            class="float-right mx-1"
            variant="danger"
            @click="modalResetFilterDialogue('confirm')"
            >entfernen</b-btn
          >
          <b-btn
            size="md"
            class="float-right"
            @click="modalResetFilterDialogue('abort')"
            >beibehalten</b-btn
          >
        </div>
      </template>
    </b-modal>
    <div
      class="card col-2 bg-light px-2"
      id="customer-order-index-query"
      ref="refCustomerOrderIndexQuery"
      style="
        overflow-x: hidden;
        overflow-y: scroll;
        max-height: 90%;
        max-width: 16.2%;
        position: fixed;
      "
    >
      <!--  v-bind:style="{''height': `${tHeight}px`, 'position': 'fixed', 'max-width':'16.2%', 'overflow-y': hideScrollbar, 'overflow-x': 'hidden' }'"   -->
      <div class="card-body bg-light px-0 pt-2" style="background: #f2f2f2">
        <form ref="refForm">
          <div role="group">
            <label for="input-customer-order-id" class="mt-0 mb-1"
              ><b>B-Nr.:</b></label
            >
            <b-input
              id="input-customer-order-id"
              v-model="userQuery.customerOrder.id"
              aria-describedby="active-query-customer-order-id"
              @keypress.enter="submit()"
              trim
              size="sm"
              type="text"
            ></b-input>
            <b-form-text
              id="active-query-customer-order-id"
              class="text-right"
              v-if="activeQuery.customerOrder.id"
              ><i>{{ activeQuery.customerOrder.id }}</i></b-form-text
            >
          </div>

          <div role="group">
            <label for="input-market-order-id" class="my-1"
              >Market-Order-Id:</label
            >
            <b-input
              id="input-market-order-id"
              v-model="userQuery.customerOrder.marketOrderId"
              aria-describedby="active-query-market-order-id"
              @keypress.enter="submit()"
              trim
              size="sm"
              type="text"
            ></b-input>
            <b-form-text
              id="active-query-market-order-id"
              v-if="activeQuery.customerOrder.marketOrderId"
              class="mb-0 pb-0 text-right"
              ><i>{{ activeQuery.customerOrder.marketOrderId }}</i></b-form-text
            >
          </div>

          <div role="group">
            <label for="select-market-account" class="my-1"
              >Market-Account:</label
            >
            <b-select
              id="select-market-account"
              v-model="userQuery.customerOrder.marketAccountId"
              :options="marketAccountOptions"
              size="sm"
            ></b-select>
            <small
              id="active-query-market-account-id"
              v-if="activeQuery.customerOrder.marketAccountId"
              class="form-text text-muted text-right"
              ><i>{{
                marketAccountOptions.find(
                  (opt) =>
                    activeQuery.customerOrder.marketAccountId === opt.value,
                ).text
              }}</i></small
            >
          </div>

          <div role="group">
            <label for="select-vendor" class="my-1">Lieferant:</label>
            <b-select
              id="select-vendor-id"
              v-model="userQuery.customerOrder.vendorId"
              :options="vendorOptions"
              size="sm"
            ></b-select>
            <small
              id="active-query-vendor-id"
              v-if="activeQuery.customerOrder.vendorId"
              class="form-text text-muted text-right"
              ><i>{{
                vendorOptions.find(
                  (opt) => activeQuery.customerOrder.vendorId === opt.value,
                ).text
              }}</i></small
            >
          </div>
          <div role="group">
            <label for="input-customer-order-id" class="mt-0 mb-1"
              ><b>EAN:</b></label
            >
            <b-input
              id="input-customer-order-id"
              ref="refEanSearch"
              v-model="
                userQuery.customerOrder.customerOrderItem.stock.material.ean
              "
              aria-describedby="active-query-ean"
              @keypress.enter="submit()"
              trim
              size="sm"
              type="text"
            ></b-input>
            <!-- note: '?.'-operator doesn't exist yet. -->
            <b-form-text
              id="active-query-ean"
              class="text-right"
              v-if="
                activeQuery.customerOrder.customerOrderItem.stock.material.ean
              "
              ><i>{{
                activeQuery.customerOrder.customerOrderItem.stock.material.ean
              }}</i></b-form-text
            >
          </div>

          <div role="group">
            <label for="select-order-state" class="my-1">Status:</label>
            <b-select
              id="select-order-state"
              v-model="userQuery.customerOrder.orderState"
              :options="orderStateOptions"
              size="sm"
            ></b-select>
            <small
              id="active-query-order-state"
              v-if="activeQuery.customerOrder.orderState"
              class="form-text text-muted text-right"
              ><i>{{
                orderStateOptions.find(
                  (opt) => activeQuery.customerOrder.orderState === opt.value,
                ).text
              }}</i></small
            >
          </div>

          <div role="group">
            <label for="select-shipping-type" class="my-1">Versandtyp:</label>
            <div>
							<multi-select
									class="mb-2 w-100"
									:value="selectedShippingTypes"
									@input="selectedShippingTypes = $event"
									:options="shippingTypeOptions"
									:multiple="true"
									label="text"
									track-by="value"
									:close-on-select="false"
									:searchable="false"
									:select-label="''"
									:deselect-label="''"
									:selected-label="'✓'"
									style="font-size: 0.7875rem !important; height: calc(1.5em + 0.5rem + 2px)"
							>
								<template #selection="{ search, values, isOpen }">
									<div class=" align-items-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
							<span
									v-for="option in values"
									:key="option.value"
									class="p-1 position-relative"
									style="font-size: 1rem; font-weight: normal !important;"
							>
								{{ option.text}}
							</span>
										<input
												v-if="isOpen"
												type="text"
												class="border-0 shadow-none"
												style="min-width: 100px; background: transparent;"
										/>
									</div>
								</template>
								<template #singleLabel>
									<span class="d-flex align-items-center"></span>
								</template>
								<template #placeholder>
									-
								</template>
								<template #caret="{ toggle }">
									<div class="multiselect__select" @mousedown.prevent.stop="toggle">
							<span class="d-flex align-items-center justify-content-center">
							</span>
									</div>
								</template>
								<template v-slot:option="{ option }">
									{{ option.text }}
								</template>
							</multi-select>
            </div>
            <small
              id="active-query-shipping-type"
              v-if="activeQuery.customerOrder.shippingType"
              class="form-text text-muted text-right"
              ><i>{{
                orderStateOptions.find(
                  (opt) => activeQuery.customerOrder.shippingType === opt.value,
                ).text
              }}</i></small
            >
          </div>

          <div role="group">
            <label for="input-material-id" class="mt-1 mb-1"
              >Artikel (<i>Material Name</i>):</label
            >
            <b-input
              id="input-material-name"
              v-model="
                userQuery.customerOrder.customerOrderItem.stock.material.name
              "
              aria-describedby="active-query-material-name"
              @keypress.enter="submit()"
              trim
              size="sm"
              type="text"
            ></b-input>
            <b-form-text
              id="active-query-material-name"
              class="text-right"
              v-if="
                activeQuery.customerOrder.customerOrderItem.stock.material.name
              "
              ><i>{{
                activeQuery.customerOrder.customerOrderItem.stock.material.name
              }}</i></b-form-text
            >
          </div>

          <div role="group">
            <label for="input-customer-order-id" class="mt-0 mb-1"
              >Sendungsnummer:</label
            >
            <b-input
              id="input-shipping-id"
              v-model="
                userQuery.customerOrder.customerOrderItem
                  .customerOrderItemDeliveryAddition.shippingId
              "
              aria-describedby="active-query-shipping-id"
              @keypress.enter="submit()"
              trim
              size="sm"
              type="text"
            ></b-input>
            <b-form-text
              id="active-query-shipping-id"
              class="text-right"
              v-if="
                activeQuery.customerOrder.customerOrderItem
                  .customerOrderItemDeliveryAddition.shippingId
              "
              ><i>{{
                activeQuery.customerOrder.customerOrderItem
                  .customerOrderItemDeliveryAddition.shippingId
              }}</i></b-form-text
            >
          </div>

          <b-button
            v-if="!showExtraOptions"
            size="sm"
            block
            variant="outline-secondary"
            class="mt-2"
            style="font-size: 110%; max-height: 28px"
            @click="toggleExtraOptions()"
            >⛛</b-button
          >
          <b-collapse v-model="showExtraOptions" class="mt-2">
            <hr class="p-1 m-1" />

            <div role="group">
              <label for="input-customer-name" class="mt-0 mb-1"
                >Kunde (Name/Email):</label
              >
              <b-input
                id="input-customer-name"
                v-model="userQuery.customerNameAndEmail"
                aria-describedby="active-query-customer-name"
                @keypress.enter="submit()"
                trim
                size="sm"
                type="text"
              ></b-input>
              <b-form-text
                id="active-query-customer-name"
                class="text-right"
                v-if="activeQuery.customerNameAndEmail"
                ><i>{{ activeQuery.customerNameAndEmail }}</i></b-form-text
              >
            </div>

            <div role="group">
              <label for="input-customer-address" class="mt-0 mb-1"
                >Kundenaddresse:</label
              >
              <b-input
                id="input-customer-address"
                v-model="userQuery.customerAddress"
                aria-describedby="active-query-customer-address"
                @keypress.enter="submit()"
                trim
                size="sm"
                type="text"
              ></b-input>
              <b-form-text
                id="active-query-customer-address"
                class="text-right"
                v-if="activeQuery.customerAddress"
                ><i>{{ activeQuery.customerAddress }}</i></b-form-text
              >
            </div>

            <div role="group">
              <label for="select-date-range" class="my-1">Zeitspanne:</label>
              <b-select
                id="select-date-range"
                v-model="userQuery.selectedDateRange.type"
                :options="dateRangeTypeOptions"
                size="sm"
                @keypress.enter="submit()"
              ></b-select>
              <small
                id="active-query-date-range"
                v-if="activeQuery.selectedDateRange.type"
                class="form-text text-muted text-right"
                ><i>{{
                  dateRangeTypeOptions.find(
                    (opt) => activeQuery.selectedDateRange.type === opt.value,
                  ).text
                }}</i></small
              >
            </div>

            <div role="group" v-if="userQuery.selectedDateRange.type !== null">
              <label for="select-date-range-from" class="my-1">von:</label>
              <b-form-datepicker
                id="date-range-from"
                class="mb-2"
                size="sm"
                :state="validateDateRange"
                v-model="userQuery.selectedDateRange.from"
                :date-format-options="{
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                }"
              ></b-form-datepicker>
              <small
                id="active-query-date-range-from"
                v-if="activeQuery.selectedDateRange.from"
                class="form-text text-muted text-right"
                ><i>{{
                  formatDate(activeQuery.selectedDateRange.from)
                }}</i></small
              >
            </div>
            <div role="group" v-if="userQuery.selectedDateRange.type !== null">
              <label for="select-date-range-to" class="my-1">bis:</label>
              <b-form-datepicker
                id="date-range-to"
                class="mb-2"
                size="sm"
                :state="validateDateRange"
                v-model="userQuery.selectedDateRange.to"
                :date-format-options="{
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                }"
              ></b-form-datepicker>
              <small
                id="active-query-date-range-to"
                v-if="activeQuery.selectedDateRange.to"
                class="form-text text-muted text-right"
                ><i>{{
                  formatDate(activeQuery.selectedDateRange.to)
                }}</i></small
              >
            </div>

            <b-button
              class="mt-2"
              size="sm"
              variant="outline-secondary"
              block
              @click="toggleExtraOptions()"
              style="font-size: 110%; max-height: 28px"
              >△</b-button
            >
            <hr class="mb-1 mt-2" />
          </b-collapse>

          <b-row class="pt-2">
            <b-col class="pr-0">
              <b-button block variant="primary" @click="reset()"
                >Reset</b-button
              >
            </b-col>
            <b-col>
              <b-overlay
                id="overlay-background-dropdown"
                :show="requestInProgress"
                spinner-type="grow"
                rounded="sm"
                spinner-small
                ><!-- overlay -->
                <b-button
                  id="coi-submit-button"
                  block
                  variant="primary"
                  @click="submit()"
                  :disabled="requestInProgress"
                  ><!-- button -->
                  Filtern
                </b-button>
              </b-overlay>
            </b-col>
          </b-row>

          <b-row v-if="authorization && authorization.master" class="p-3 mt-0">
            <!--v-model="activeSqlQuery" -->
            <b-textarea
              :value="activeSqlQuery"
              @input="$emit('update:activeSqlQuery', $event)"
              disabled
              rows="9"
              style="font-family: &quot;Lucida Console&quot;, monospace"
            ></b-textarea>
          </b-row>
        </form>
      </div>
    </div>
  </div>
</template>
<style scoped>
label {
  padding: 0px !important;
}
:deep(.multiselect__tags) {
	min-height: 28px !important;
	max-height: 0.7875rem !important;
	padding-top: 0;
}
:deep(.multiselect__select) {
	min-height: 28px !important;
	max-height: 0.7875rem !important;
	padding-top: 0;
}

:deep(.multiselect__tags span) {
	font-size: 0.7875rem !important;
}
</style>
<script>
import { useUserPreferenceStore } from "../../stores/UserPreferenceStore";

export default {
  setup() {
    const userPreferenceStore = useUserPreferenceStore();
    return { userPreferenceStore };
  },
  name: "coi-query",
  props: [
    "activeSqlQuery",
    "authorization",
    "marketAccounts",
    "orderStates",
    "shippingTypes",
    "requestInProgress",
    "vendors",
    "",
  ],
  data() {
    return {
      tHeight: this.window.innerHeight - 75,
      hideScrollbar: "scroll",
      userQuery: this.newQueryScaffolding(), // query which the user can construct and manipulate
      activeQuery: this.newQueryScaffolding(), // query which the user constructed and subseq. executed
      showExtraOptions: false, // switch to toggle the triangle input fields
			selectedShippingTypes: [],
      dateRangeTypeOptions: [
        { value: null, text: "-" },
        { value: "orderTime", text: "Bestelldatum" },
        { value: "shipmentTime", text: "Versanddatum" },
      ],
    };
  },
  watch: {
    requestInProgress: function (n) {
      if (n) this.$refs.refEanSearch.focus();
    },
		selectedShippingTypes: function (n) {
			if (n && n.length > 0) {
				this.userQuery.customerOrder.shippingTypes = n.map((type) => {return type.value; },
				);
			}
		},
  },
  computed: {
    validateDateRange: function () {
      const from = Date.parse(this.userQuery.selectedDateRange.from);
      const to = Date.parse(this.userQuery.selectedDateRange.to);
      return from <= to;
    },
    marketAccountOptions: function () {
      if (!this.marketAccounts) return []; // safer than mutating prop, notice: ...null or ...undefined throws error, since both aren't iterable!
      return [
        { val: null, text: "-" },
        ...this.marketAccounts.map((m) => {
          return { value: m.id, text: m.name };
        }),
      ];
    },
    orderStateOptions: function () {
      if (!this.orderStates) return [];
      return [
        { val: null, text: "-" },
        ...Object.keys(this.orderStates.types).map((v) => {
          return { value: parseInt(v), text: this.orderStates.types[v] };
        }),
      ];
    },
    shippingTypeOptions: function () {
      if (!this.shippingTypes) return [];

      return Object.keys(this.shippingTypes.types).map((v) => {
        return { value: parseInt(v), text: this.shippingTypes.types[v] };
      });
    },
    vendorOptions: function () {
      if (!this.vendors) return [];
      return [
        { val: null, text: "-" },
        ...this.vendors.map((v) => {
          return { value: v.id, text: v.name };
        }),
      ];
    },
  },
  methods: {
    formatDate(d) {
      return moment(d).format("DD.MM.YYYY");
    },

    modalResetFilterDialogue(opt) {
      this.$bvModal.hide("modal-filter-removal-notice");
      if (opt === "confirm") {
        this.userQuery.selectedDateRange.type = null;
        this.userQuery.selectedDateRange.from = null;
        this.userQuery.selectedDateRange.to = null;
        this.userQuery.customerNameAndEmail = null;
        this.userQuery.customerAddress = null;
        this.showExtraOptions = false;
      } else if (opt === "abort") {
        // this.modalFilterRemovalNoticeState = false;
      } else {
        alert("unknown option");
      }
    },
    newQueryScaffolding() {
      //WARNING: if you change this, you need to change it in the other components as well!
      return {
        limit: 10,
        offset: 0,
        count: null, // ~~if count is set, we use limit and offset~~ too opaque, using bool instead
        orderBy: null,
        orderByAscending: true,
        lastQueryTimestamp: null, //is timestamp of last query run, additionally we can add lateron a button "re-run query", this way we can re-run the query if lastQueryTimestamp is greater than some value.
        selectedDateRange: {
          type: null,
          from: null,
          to: null,
        },
        customerNameAndEmail: null, // this is not in customer object because it isn't a reference to a specific table member, it is both firstName and lastName
        customerAddress: null, // member represents all address metadata (street1, street2, zipcode, etc.)
        customerOrder: {
          id: null, // TODO check if coi.id shouldn't be used instead.
          customerOrderItem: {
            id: null,
            customerOrderItemDeliveryAddition: { shippingId: null },
            stock: { material: { name: null, ean: null } },
          },
          marketOrderId: null,
          marketAccountId: null,
          orderState: null,
          orderTime: null,
          vendorId: null,
          shippingTypes: null,
        },
      };
    },
    toggleExtraOptions() {
      if (!this.showExtraOptions) {
        this.showExtraOptions = true;
      } else {
        if (
          this.userQuery.selectedDateRange.type ||
          this.userQuery.customerNameAndEmail ||
          this.userQuery.customerAddress
        ) {
          this.$bvModal.show("modal-filter-removal-notice");
        } else {
          this.showExtraOptions = false;
        }
      }
    },
    resetQueryInputFields() {
      // only resets the text-input fields. Dates and dropdowns aren't touched.
      //const temp = _.cloneDeep(this.userQuery);
      this.userQuery = this.newQueryScaffolding();
      //copy over drop-down menus:
      this.userQuery.customerOrder.marketAccountId =
        this.activeQuery.customerOrder.marketAccountId;
      this.userQuery.customerOrder.vendorId =
        this.activeQuery.customerOrder.vendorId;
      this.userQuery.customerOrder.orderState =
        this.activeQuery.customerOrder.orderState;
      this.userQuery.selectedDateRange = this.activeQuery.selectedDateRange;
      this.userQuery.customerOrder.shippingTypes = this.activeQuery.customerOrder.shippingTypes;
    },
    reset() {
      if (this.requestInProgress) {
        // I guess this effectively aborts waiting for the transaction to complete.
        location.reload();
      }
      this.selectedShippingTypes = [];
      this.userQuery = this.newQueryScaffolding();
    },
    submit() {
			this.formatCustomerOrderId()
      this.userQuery.offset = 0;
      this.activeQuery.offset = 0;
      this.activeQuery = _.cloneDeep(this.userQuery);
      this.$emit("mutatedActiveQuery", this.activeQuery);
      this.resetQueryInputFields();
    },
    formatCustomerOrderId() {
    	if(this.userQuery.customerOrder.id == null || this.userQuery.customerOrder.id == "") return;
			this.userQuery.customerOrder.id = this.userQuery.customerOrder.id.replace(/[a-zA-Z]/g, "").trim();
		},
  },
  mounted() {
    this.$refs.refEanSearch.focus();
  },
};
</script>
